import { useAuth0 } from '@auth0/auth0-react';
import { useQuery } from '@tanstack/react-query';
import API from 'api/API';
import { QueryKeys } from 'api/models/QueryKeys';
import { SurgeonsRequestFilters } from 'api/models/Surgeons';
import { useHasSurgeonsPermission } from 'hooks/useHasSurgeonsPermission';

export const useSurgeons = (params: SurgeonsRequestFilters, enabled = true) => {
  const { isAuthenticated } = useAuth0();
  const { data: hasSurgeonsPermission } = useHasSurgeonsPermission();

  return useQuery({
    queryKey: [QueryKeys.Surgeons, params],
    queryFn: async () => API.surgeons.getSurgeons(params),
    enabled: enabled && isAuthenticated && hasSurgeonsPermission,
  });
};
